import type { OrgTenantTag } from '@onefootprint/request-types/dashboard';
import { Checkbox } from '@onefootprint/ui';
import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import FiltersDrawer from '@/components/filters-drawer';
import type { FormData } from '../../drawer-filter.type';
type TagsListProps = {
  tags: OrgTenantTag[];
};
const TagsList = ({
  tags
}: TagsListProps) => {
  const {
    t
  } = useTranslation('common', {
    keyPrefix: 'pages.entities.filters.drawer.tags'
  });
  const {
    control,
    getValues
  } = useFormContext<FormData>();
  // biome-ignore lint/plugin: deps [tags] deliberately narrower than getValues() — freezes the sort order so the list doesn't reshuffle on toggle
  const sortedTags = useMemo(() => {
    const selectedTags = new Set(getValues('tags'));
    return [...tags].sort((a, b) => {
      if (selectedTags.has(a.tag)) {
        return -1;
      }
      if (selectedTags.has(b.tag)) {
        return 1;
      }
      return 0;
    });
  }, [tags]);
  return <Controller control={control} name="tags" render={({
    field
  }) => {
    const selected = field.value ?? [];
    return <FiltersDrawer.SearchList items={sortedTags} getSearchText={tag => tag.tag} placeholder={t($ => $.searchPlaceholder)} emptyText={t($_0 => $_0.empty)} renderItem={({
      tag: tag_0
    }) => <Checkbox key={tag_0} label={tag_0} checked={selected.includes(tag_0)} onChange={() => field.onChange(selected.includes(tag_0) ? selected.filter(value => value !== tag_0) : [...selected, tag_0])} />} />;
  }} />;
};
export default TagsList;